import React, { useEffect, useState } from "react";
import { Constants } from "@eagerdog/constants";

import { helperService } from "src/services/helper.service";

import Dropdown, { IOption } from "src/components/Dropdown/Dropdown";
import Input from "src/components/Input/Input";

import "./CWagsObedienceResults.scss";

interface IProps {
  result: any,
  onChange(result: any): void
}

const CWagsObedienceResults: React.FC<IProps> = (props) => {
  const getOptionLabel = (id: string) => {
    switch (id) {
      case Constants.score_result_type.qualified:
        return "Qualified";
      case Constants.score_result_type.not_qualified:
        return "Not Qualified";
      case Constants.score_result_type.absent:
        return "Absent";
    }

    return "None";
  }

  const [totalScore, setTotalScore] = useState<string>(
    props.result.obedience?.total_score !== undefined 
      ? props.result.obedience?.total_score.toString() 
      : ""
  );

  const [result, setResult] = useState<IOption>({ 
    id: props.result.obedience?.result_type ? props.result.obedience?.result_type : Constants.score_result_type.qualified,
    value: props.result.obedience?.result_type ? getOptionLabel(props.result.obedience?.result_type) : "Qualified"
  });

  const resultOptions: IOption[] = [
    { id: "None", value: "None" },
    { id: Constants.score_result_type.qualified, value: "Qualified" },
    { id: Constants.score_result_type.not_qualified, value: "Not Qualified" },
    { id: Constants.score_result_type.absent, value: "Absent" }
  ];

  const pResult = helperService.usePrevious(result);
  const pTotalScore = helperService.usePrevious(totalScore);

  // Check if current result doesn't need score (Not Qualified or Absent)
  const isNonScoringResult = [
    Constants.score_result_type.not_qualified,
    Constants.score_result_type.absent
  ].includes(result.id);

  let { onChange } = props;

  useEffect(() => {
    let _pResult: any = pResult as any;

    if ((_pResult !== undefined && _pResult.id !== result.id) || (totalScore !== pTotalScore)) {
      let changePayload: any = {
        result_type: result.id,
        element_deductions: [], // Required by backend validation
      };

      if (isNonScoringResult) {
        // For non-scoring results (NQ, Absent), clear score data
        changePayload.total_score = null;
      } else {
        changePayload.total_score = totalScore !== "" ? Number(totalScore) : null;
      }

      onChange(changePayload);
    }
  }, [result, pResult, totalScore, pTotalScore, onChange, isNonScoringResult]);

  return (
    <div className="CWagsObedienceResults">
      <div className="row">
        <Dropdown 
          value={result} 
          onChange={(e: any, value: IOption) => { setResult(value); }} 
          label="Result" 
          options={resultOptions} 
          placeholder="" 
        />
      </div>
      
      {!isNonScoringResult && (
        <div className="row">
          <Input 
            type="number" 
            onChange={(e: any) => { setTotalScore(e.target.value); }} 
            label="Total Score" 
            placeholder="Enter total score" 
            defaultValue={totalScore} 
          />
        </div>
      )}
    </div>
  );
};

export default CWagsObedienceResults;

